'use client';

import { useEffect } from 'react';
import { initSentry } from '@/lib/sentry';

/**
 * Mounts once and calls initSentry() in the browser via useEffect.
 *
 * Why this exists: in Next.js with `output: 'export'`, the root
 * layout is a server component whose module-level code runs at
 * BUILD time (Node.js, no window). Calling initSentry() directly
 * from layout.tsx therefore short-circuited on the
 * `typeof window === 'undefined'` guard and Sentry never
 * initialised in the browser. Putting the call inside a
 * `'use client'` component with a useEffect guarantees it runs
 * client-side after hydration, which is what we want.
 */
export function SentryInit() {
  useEffect(() => {
    initSentry();
  }, []);
  return null;
}
